import { axiosInstance } from '../utils/axios';

import { contentType, requestHeaders } from '../constants/requestHeaders';

export const getHoveredOrganization = ({ path: { orgId } }, extraData) =>
  axiosInstance.get(`/${orgId}/hovercard`, extraData);

export const getAllOrganizations = ({ params: { count, offset } }, extraData) =>
  axiosInstance.get(`/orgs`, {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
      count,
      offset,
    },
  });

export const postOrganization = (
  { body: { id, name, description, properties }, params: { isPrivate } },
  extraData,
) =>
  axiosInstance
    .post(
      '/',
      {
        id,
        name,
        description,
        properties,
      },
      {
        ...extraData,
        params: {
          private: isPrivate,
        },
      },
    )
    .then(() =>
      axiosInstance.get(`/${id}/hovercard`, {
        ...extraData,
        params: {
          ...extraData?.params,
          refresh: Math.random(),
        },
      }),
    );

export const putOrganization = (
  { path: { orgId }, body: { name, description, properties } },
  extraData,
) =>
  axiosInstance
    .put(
      `/${orgId}`,
      {
        name,
        description,
        properties,
      },
      extraData,
    )
    .then(() =>
      axiosInstance.get(`/${orgId}/hovercard`, {
        ...extraData,
        params: {
          ...extraData?.params,
          refresh: Math.random(),
        },
      }),
    );

export const postOrganizationProfileImage = ({ orgId, formData }, extraData) =>
  axiosInstance.post(`/${orgId}/profile`, formData, {
    ...extraData,
    headers: requestHeaders.contentType(contentType.multipartFormData),
  });

export const postOrganizationCoverPic = ({ orgId, formData }, extraData) =>
  axiosInstance.post(`/${orgId}/cover`, formData, {
    ...extraData,
    headers: requestHeaders.contentType(contentType.multipartFormData),
  });
